import React from 'react';
import classNames from 'classnames';
import { Scrollbars } from 'react-custom-scrollbars';
import {
  renderTrackHorizontalDefault,
  renderTrackVerticalDefault,
  renderThumbHorizontalDefault,
  //renderThumbVerticalDefault,
} from 'react-custom-scrollbars/lib/Scrollbars/defaultRenderElements';

function Scrollbar({ children, className, ...otherProps }) {
  const containerClass = classNames({
    'scrollbar-container': true,
    [className]: className,
  });

  return (
    <Scrollbars
      className={containerClass}
      autoHide={true}
      autoHeight={true}
      renderTrackHorizontal={props => renderTrackHorizontalDefault({ ...props, className: 'track-horizontal' })}
      renderTrackVertical={props => renderTrackVerticalDefault({ ...props, className: 'track-vertical' })}
      renderThumbHorizontal={props => renderThumbHorizontalDefault({ ...props, className: 'thumb-horizontal' })}
      renderThumbVertical={props => renderThumbHorizontalDefault({ ...props, className: 'thumb-vertical' })}
      {...otherProps}>
      {children}
    </Scrollbars>
  );
}

export default Scrollbar;
